const state = {
  djxxlist:[],
  dyxxlist:[],
  dfzdlist:[],
  hhxxlist:[],
  sdhtlist:[],
  htdllist:[],
  htgllist:[],
  htwjlist:[],
  khjsgllist:[],
  dlsjsgllist:[],
  khdljyjslist:[],
  khdlsbjslist:[],
  jsyjlist:[],
  khgllist:[],
  ydxxlist:[],
  yhgllist:[]
}

const mutations = {
  COMMIT_DATA (state,data) {
    state[data.name] = data.data
  },
}

const actions = {
  someAsyncTask ({ commit }, key,data) {
    // do something async
    console.log( key,data)
    commit('COMMIT_DATA',key, data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
